import type { NavigateFunction } from 'react-router-dom';

/** Always open a blank chat thread UI (force remount even when already on /chat). */
export function startNewMcpChat(navigate: NavigateFunction): void {
  navigate('/chat', {
    replace: false,
    state: { mcpNewChat: Date.now() }
  });
}
